import "vite/modulepreload-polyfill";
import "../polyfills/polyfills"; // Ensure this is the first import
import "@/assets/scss/index.scss";
import { useNg } from "@/shared/ng/ng-integration";
import { useKeepAlive } from "@/shared/composables/use-keep-alive";
import { useGdpr } from "@/shared/composables/use-gdpr";
import { useVue } from "@/shared/use-vue";
import { useChat } from "@/shared/composables/use-chat";
import { useAppInsights } from "@/shared/utils/logger/app-insights";
import { isDevelopmentEnv } from "@/shared/utils/environment-variables";

window.dataLayer = window.dataLayer || [];

import { ngOpenPage } from "./shared/ng/ng-open-page";

useAppInsights().init();
useVue();

useNg(ngOpenPage);
useKeepAlive();
useGdpr().init();
useChat().registerChatToWindow();

// BEWARE: If you want to stay sane you want to have logStoreChanges set to false by default.
// You can find it under Pinia plugin Setting as "Notify about new/deleted stores" which not fully describes what it actually does.
// Otherwise, you'll face big performance problems everytime you clear site data,
// and it is a lot time-consuming to turn it off again because dev tools will crash several times,
// will be unable to load Pinia plugin or whatever other complications.
// P.S.: Most probably useless around year 2050 once they'll resolve these performance problems (no progress since the last year).
if (isDevelopmentEnv()) {
    const PINIA_DEVTOOLS_KEY = "__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__dev.esm.pinia__";
    const piniaSettings = JSON.parse(localStorage.getItem(PINIA_DEVTOOLS_KEY) || "{}");
    if ([undefined, true].includes(piniaSettings?.logStoreChanges)) {
        localStorage.setItem(PINIA_DEVTOOLS_KEY, JSON.stringify({ ...piniaSettings, logStoreChanges: false }));
    }
}
